import { TextBox } from '@apply/components';
import { usePaymentStore } from '../../../../../state/paymentStore';

export const Address1: React.FC = () => {
    const address1 = usePaymentStore((s) => s.address1);
    const set_address1 = usePaymentStore((s) => s.set_address1);

    return (
        <TextBox
            value={address1}
            onChange={(value) => set_address1(value)}
            label='Street'
            required={true}
        />
    );
};
